/**
 * Compares two sets of string IDs and checks if they are identical.
 *
 * Two sets are considered identical if they have the same size and
 * contain exactly the same elements, regardless of order.
 *
 * @param {Set<string>} a - The first set of string IDs.
 * @param {Set<string>} b - The second set of string IDs.
 * @returns {boolean} True if both sets are identical, false otherwise.
 */
const areSetsEqual = (a: Set<string>, b: Set<string>): boolean => {
  if (a.size !== b.size) return false;
  for (const value of a) {
    if (!b.has(value)) return false;
  }
  return true;
};
export default areSetsEqual;
